import {
  Mountain, Leaf, Caravan, Compass, Laptop, Heart, MapPin, Landmark,
  Sun, TreePine, Users, Music, Building, Minus, Footprints, Scale,
  TrendingUp, Zap, Wallet, Banknote, Gem, Crown, UtensilsCrossed,
  ShoppingBag, Moon, Plane, Hotel, BedDouble, Home, House, Palmtree,
  Tent, Castle, Flag, Globe, Waves, Navigation, FileText, BookOpen,
  StickyNote, Library, Clock, User, Baby, PawPrint, HelpCircle, PersonStanding
} from 'lucide-react';

const ICON_MAP = {
  Mountain, Leaf, Caravan, Compass, Laptop, Heart, MapPin, Landmark,
  Sun, TreePine, Users, Music, Building, Minus, Footprints, Scale,
  TrendingUp, Zap, Wallet, Banknote, Gem, Crown, UtensilsCrossed,
  ShoppingBag, Moon, Plane, Hotel, BedDouble, Home, House, Palmtree,
  Tent, Castle, Flag, Globe, Waves, Navigation, FileText, BookOpen,
  StickyNote, Library, Clock, User, Baby, PawPrint, HelpCircle, PersonStanding
};

export function getIcon(name) {
  return ICON_MAP[name] || MapPin;
}

export function IconFromName({ name, ...props }) {
  const Icon = getIcon(name);
  return <Icon {...props} />;
}
